import React from 'react'
import { Provider } from 'redux-zero/react'

import store from './src/store/createStore'

// const store = createStore()

// eslint-disable-next-line react/display-name,react/prop-types
export default ({ element }) => <Provider store={store}>{element}</Provider>
